import Swiper from 'swiper';
import Section from '../Section';

export default class TextAdverts extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    const swiperContainer = this.element.querySelector('.swiper-container');
    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      watchOverflow: true,
      autoHeight: true,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      speed: 1000,
    });
  }

}
